export const CHART_LAYER_EVENTS = {
    OPEN_CHART_EDITOR: 'chart-layer/open-chart-editor',
};
